import { faArrowDown, faArrowUp, faExpand } from '@fortawesome/pro-light-svg-icons';
import StockHtmlHelper from '../stocks/StockHtmlHelper';
var PortfolioStockListMixin = {
    data() {
        return {
            icons: {
                sortAsc: faArrowUp,
                sortDesc: faArrowDown,
                expand: faExpand
            },
            sortedPortfolioStock: [],
            stockHtmlHelper: undefined,
            sorter: {
                by: 'totalMaterializedGrossValueIncludingUnrealized',
                asc: false
            }
        }
    },
    computed: {
        todayGainTitle() {
            return this.$t("Home.dashboard.overview.portfolioStock.todayGain") + ` (${this.userPreferredCurrency})`;
        },
        totalGainTitle() {
            return this.$t("Home.dashboard.overview.portfolioStock.totalGain") + ` (${this.userPreferredCurrency})`;
        },
        totalValueTitle() {
            return this.$t("Home.dashboard.overview.portfolioStock.totalValue") + ` (${this.userPreferredCurrency})`;
        },
        aggregatedPortfolioStock() {
            return this.$store.getters.aggregatedPortfolioStock;
        },
        sortByTodayChangeIcon() {
            return this.getSortIconByKey('changePercent');
        },
        sortByTodayGainIcon() {
            return this.getSortIconByKey('dayChange');
        },
        sortByTotalGainIcon() {
            return this.getSortIconByKey('totalProfitIncludingUnrealized');
        },
        sortByTotalValueIcon() {
            return this.getSortIconByKey('totalMaterializedGrossValueIncludingUnrealized');
        }
    },
    beforeMount() {
        this.stockHtmlHelper = new StockHtmlHelper();
        this.sortAggregatedPortfolioStock({ by: this.sorter.by });
    },
    methods: {
        goToPortfolioOverview() {
            this.$router.push({ name: 'PortfolioOverview' });
        },
        getSortIconByKey(key) {
            return this.sorter.by !== key ? null : this.sorter.asc ? this.icons.sortAsc : this.icons.sortDesc;
        },
        showStock(item) {
            this.$router.push({ name: 'Stock', params: { id: item.stockId } });
        },
        stockPriceInfo(stock) {
            return {
                currency: stock.currency.toUpperCase(),
                lastPrice: stock.stockDateTimeSnapshot.price
            }
        },
        stockChangeInfo(stock) {
            return {
                changeAmount: stock.stockDateTimeSnapshot.change,
                changePercent: stock.stockDateTimeSnapshot.changePercent
            }
        },
        totalMarketValue(stock) {
            return {
                currency: stock.statistics.normalizedWithPreferredCurrency.currency,
                price: stock.statistics.normalizedWithPreferredCurrency.totalMaterializedGrossValueIncludingUnrealized,
                showCurrency: false
            }
        },
        getValueByPath(obj, path, key) {
            // path peut avoir plus d'un niveau, ex: 'statistics.normalizedWithPreferredCurrency'
            return path.split('.').reduce((acc, k) => acc && acc[k], obj)[key];
        },
        sortAggregatedPortfolioStock({ by }) {
            const asc = this.sorter.by === by ? !this.sorter.asc : false;
            this.sorter = { by, asc };
            const data = JSON.parse(JSON.stringify(this.aggregatedPortfolioStock));
            const part = by === 'changePercent' ? 'stockDateTimeSnapshot' : 'statistics.normalizedWithPreferredCurrency';
            this.sortedPortfolioStock = data.sort((a, b) => {
                const va = this.getValueByPath(a, part, by);
                const vb = this.getValueByPath(b, part, by);
                if (va < vb) {
                    return asc ? -1 : 1;
                };
                if (va > vb) {
                    return asc ? 1 : -1;
                }
                return 0;
            });
        },
        formatPrice(price) {
            return this.stockHtmlHelper.formatPrice(price);
        },
        formatPriceWithSign(price) {
            return `${price > 0 ? '+' : ''}${this.stockHtmlHelper.formatPrice(price)}`;
        },
        changeClass(change) {
            return `change${change < 0 ? ' negative' : change > 0 ? ' positive' : ''}`
        }
    },
    watch: {
        aggregatedPortfolioStock: {
            handler() {
                this.sortAggregatedPortfolioStock({ by: this.sorter.by });
            },
            deep: true
        }
    }
}
export default PortfolioStockListMixin;